<template>
  <div>
    <a-card>
      <v-row>
        <span class="subtitle-2">Email Sending Options</span>
      </v-row>
      <v-row
        ><div>
          <input type="checkbox" v-model="sendEmailsIndividually" @change="() => updateSelection(this.value)" />
          <span class="caption ml-2">Send emails individually</span>
        </div></v-row
      >
    </a-card>
    <a-card>
      <a-select widelabel label="Supplier Type *" :items="supplierTypes" v-model="type" @input="clearSelected" />

      <SelectSupplierTable
        :maptype="type"
        :value="value"
        :roomBreakdownData="roomBreakdownData"
        @input="(v) => updateSelection(v)"
      />
    </a-card>
  </div>
</template>

<script>
import { SuppliersMenu } from "@/config/menus";
import SelectSupplierTable from "./_SelectSupplierTable";
export default {
  props: {
    day: String,
    value: Object,
    roomBreakdownData: Object,
  },
  components: {
    SelectSupplierTable,
  },
  data() {
    return {
      type: "",
      sendEmailsIndividually: false,
    };
  },
  computed: {
    supplierTypes() {
      var list = [];
      SuppliersMenu.FULL.forEach((item) => {
        list.push({
          label: item.title,
          value: item.module,
          dbkey: item.alt,
        });
      });
      return list;
    },
  },
  methods: {
    clearSelected(type) {
      const emptyData = {
        contacts: {},
        ignoreProducts: {},
        groupBy: {},
        admins: {},
        sendEmailsIndividually: this.sendEmailsIndividually,
      };
      this.$emit("input", emptyData);
      const selectedType = this.supplierTypes.find((x) => x.value === type);
      this.$emit("setType", selectedType);
    },
    updateSelection(value) {
      const updatedData = { ...value, sendEmailsIndividually: this.sendEmailsIndividually };
      this.$emit("input", updatedData);
    },
  },
};
</script>
